import { lazy } from 'react';

const AppBanner = lazy(
	() =>
		import(
			/* webpackChunkName: "appbanner" */
			'./app-banner.js'
		)
);

export default AppBanner;
